var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stretch-vertical home"},[_c('div',{staticClass:"text-content-section stretch-vertical",domProps:{"innerHTML":_vm._s(_vm.pageContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }